module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4d3c44e440a7d664dd4dbb11c1413f21.png";